import { ActionTypes } from '../../constants/ActionTypes';

export const onGetSticky = (notesList: any) => {
  return {
    type: ActionTypes.GET_STICKY,
    notesList,
  };
};

export const fetchStickySuccess = (notesList: any) => {
  return {
    type: ActionTypes.FETCH_ALL_NOTES_SUCCESS,
    payload: notesList,
  };
};

export const onUpdateSticky = (notesList: any) => {
  return {
    type: ActionTypes.NOTES_UPDATE,
    notesList,
  };
};

export const updateStickySuccess = (notesList: any) => {
  return {
    type: ActionTypes.UPDATE_ALL_NOTES_SUCCESS,
    payload: notesList,
  };
};
